export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8986.95f2a116.jpg";